import { useLanguage } from '../utils/LanguageContext';
import translations from '../components/ComponentsTranslations.lang.json';
import { Typography, Card } from 'antd';
import { ValidatedForm, FormSubmit, FormChoice } from './common/ValidatedForm';
import { updateUserFundingSourceSchema } from '../shared/validations/userValidations';
import { FundingSource } from '../shared/constants/userConstants';
import { useAuth } from '../utils/AuthContext.js';

const { Text } = Typography;

const FundingSourceForm = ({ onFinish }) => {
  const { lang, optionsForEnum } = useLanguage(translations);
  const { user, api } = useAuth();

  return (
    <ValidatedForm
      key="FundingSourceForm"
      schema={updateUserFundingSourceSchema}
      initialValues={{ fundingSource: user.fundingSource }}
      handleSubmit={api.updateUserFundingSource}
      onFinish={onFinish}
    >
      <Card
        title={
          <Text style={{ fontSize: '14px', whiteSpace: 'normal', wordWrap: 'break-word' }}>
            {lang('sourceOfFunding')}
          </Text>
        }
      >
        <FormChoice name="fundingSource" options={optionsForEnum(FundingSource)} type="button" />
      </Card>
      <FormSubmit>{lang('next')}</FormSubmit>
    </ValidatedForm>
  );
};

export default FundingSourceForm;
